import Entity from '../entity'

export default class Activity extends Entity<number>{
    activityTypeId: number  = null;
    name: string  = null;
    keywords: string  = null;
    activityNo: string  = null;
    description: string  = null;
    details: string  = null;
    coverImageUrl: string  = null;
    priority: number  = null;
    tenantId: number  = null;
    isPublished: boolean;
    beginTime: Date  = null;
    endTime: Date  = null;
    activityImageUrl: string  = null;
    pageUrl: string  = null;
    buttonImageUrl: string  = null;
    buttonMarginTop: number  = null;
    shareImageUrl: string  = null;
    shareTitle: string  = null;
    remark: string  = null;
}